import { ROW_ACTIONS_MENU_LABELS } from './RowActionsMenu.labels';

export const ACTIONS_COLUMN_STYLE = { width: '80px' } as const;

export const DELETE_LABEL_BY_ENTITY: Record<'session' | 'test', string> = {
	session: ROW_ACTIONS_MENU_LABELS.DELETE_SESSION,
	test: ROW_ACTIONS_MENU_LABELS.DELETE_TEST
};
